import styled from 'styled-components';
import {theme} from '@styles/theme';

export const UsersBlockWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  border: 2px solid ${theme.colors.basic06};
  border-radius: ${theme.roundedBig};
`;

export const UsersAvatarsBlock = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
`;

export const UserAvatarWrapper = styled.div`
  &:not(:last-child) {
    margin-left: -8px;
  }
`;
